var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "validation-observer",
        { ref: "formValidator" },
        [
          _c("page-header", {
            attrs: {
              "on-return": () => _vm.$router.go(-1),
              "on-save": _vm.save,
              page: _vm.page
            }
          }),
          _c("board", { staticClass: "mb-4", attrs: { details: _vm.board } }),
          _c("section-title", { attrs: { title: "Información General" } }),
          _c("div", { staticClass: "row mb-4 pl-3" }, [
            _c(
              "div",
              { staticClass: "col-sm" },
              [
                _c("validation-provider", {
                  attrs: { name: "Teléfono", rules: "required|length:11" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-input", {
                            attrs: {
                              "custom-error-msg":
                                _vm.validationMessages.required,
                              error: errors[0],
                              label: "Teléfono:",
                              "mask-type": "Phone",
                              placeholder: "(___) ___-____"
                            },
                            model: {
                              value: _vm.model.locationTelephoneNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "locationTelephoneNo", $$v)
                              },
                              expression: "model.locationTelephoneNo"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm" },
              [
                _c("custom-input", {
                  attrs: {
                    label: "Fax:",
                    "mask-type": "Phone",
                    placeholder: "(___) ___-____"
                  },
                  model: {
                    value: _vm.model.locationTelephoneFaxNo,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "locationTelephoneFaxNo", $$v)
                    },
                    expression: "model.locationTelephoneFaxNo"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm" },
              [
                _c("custom-input", {
                  attrs: {
                    label: "Dirección Web:",
                    placeholder: "www.websitedomain.com"
                  },
                  model: {
                    value: _vm.model.locationWebsiteUrl,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "locationWebsiteUrl", $$v)
                    },
                    expression: "model.locationWebsiteUrl"
                  }
                })
              ],
              1
            )
          ]),
          _c("section-title", {
            attrs: { title: "Información de Localización" }
          }),
          _c("div", { staticClass: "row mb-4 pl-3" }, [
            _c(
              "div",
              { staticClass: "col-md-4 col-sm-12" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-drop-down", {
                            ref: "locationTypeRef",
                            attrs: {
                              clearable: false,
                              "custom-error-msg": _vm.validationMessages.select,
                              error: errors[0],
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Tipo de Localización:",
                              options: _vm.locationTypes,
                              placeholder: "Seleccione"
                            },
                            on: { input: _vm.setLocationTypeValue },
                            model: {
                              value: _vm.locationType,
                              callback: function($$v) {
                                _vm.locationType = $$v
                              },
                              expression: "locationType"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm.showProviderOfficeSection || _vm.isAssistedTherapy
              ? _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-12" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    "custom-error-msg":
                                      _vm.validationMessages.required,
                                    error: errors[0],
                                    label: "Nombre:"
                                  },
                                  model: {
                                    value: _vm.model.locationName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "locationName", $$v)
                                    },
                                    expression: "model.locationName"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3787416227
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showCSEESection
              ? _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-12" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  attrs: {
                                    "custom-error-msg":
                                      _vm.validationMessages.select,
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "Centro:",
                                    options: _vm.centers,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.center,
                                    callback: function($$v) {
                                      _vm.center = $$v
                                    },
                                    expression: "center"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1677219261
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showCAATSection
              ? _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-12" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  attrs: {
                                    "custom-error-msg":
                                      _vm.validationMessages.select,
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "CAAT:",
                                    options: _vm.caatCenters,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.caat,
                                    callback: function($$v) {
                                      _vm.caat = $$v
                                    },
                                    expression: "caat"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2402779392
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showCAATSection
              ? _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-12" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  attrs: {
                                    clearable: false,
                                    "custom-error-msg":
                                      _vm.validationMessages.select,
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "Municipio:",
                                    options: _vm.caatMunicipalities,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.caatMunicipality,
                                    callback: function($$v) {
                                      _vm.caatMunicipality = $$v
                                    },
                                    expression: "caatMunicipality"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1454282354
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showProviderOfficeSection ||
            _vm.showCSEESection ||
            _vm.isAssistedTherapy
              ? _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-12" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  attrs: {
                                    clearable: false,
                                    "custom-error-msg":
                                      _vm.validationMessages.select,
                                    disabled: _vm.municipalityReadOnly,
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "Municipio:",
                                    options:
                                      _vm.showProviderOfficeSection ||
                                      _vm.isAssistedTherapy
                                        ? _vm.municipalities
                                        : _vm.centerMunicipalities,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.municipality,
                                    callback: function($$v) {
                                      _vm.municipality = $$v
                                    },
                                    expression: "municipality"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        260508806
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showSchoolSection
              ? _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-12" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  attrs: {
                                    "custom-error-msg":
                                      _vm.validationMessages.select,
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "Región:",
                                    options: _vm.regions,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.region,
                                    callback: function($$v) {
                                      _vm.region = $$v
                                    },
                                    expression: "region"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        141520248
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showSchoolSection
              ? _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-12" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  attrs: {
                                    clearable: false,
                                    "custom-error-msg":
                                      _vm.validationMessages.select,
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "Distrito:",
                                    options: _vm.districts,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.district,
                                    callback: function($$v) {
                                      _vm.district = $$v
                                    },
                                    expression: "district"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2940083822
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showSchoolSection
              ? _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-12 mt-3" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  attrs: {
                                    "custom-error-msg":
                                      _vm.validationMessages.select,
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "Escuela:",
                                    options: _vm.schools,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.school,
                                    callback: function($$v) {
                                      _vm.school = $$v
                                    },
                                    expression: "school"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3613547060
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm.showDemographicInfoSection
            ? _c(
                "div",
                { staticClass: "mb-5" },
                [
                  _c("section-title", {
                    attrs: { title: "Información de Dirección Física" }
                  }),
                  _c("div", { staticClass: "row mb-4 pl-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.validationMessages.required,
                                        error: errors[0],
                                        label: "Dirección (Línea 1):"
                                      },
                                      model: {
                                        value:
                                          _vm.model.primayAddressInformation
                                            .addressLine1,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.primayAddressInformation,
                                            "addressLine1",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.primayAddressInformation.addressLine1"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            834191062
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.validationMessages.select,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        label: "Municipio:",
                                        options: _vm.municipalities,
                                        placeholder: "Seleccione"
                                      },
                                      model: {
                                        value: _vm.addressMunicipality,
                                        callback: function($$v) {
                                          _vm.addressMunicipality = $$v
                                        },
                                        expression: "addressMunicipality"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3728206716
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.validationMessages.required,
                                        error: errors[0],
                                        label: "Código Postal:",
                                        "mask-type": "ZipcodeExt",
                                        placeholder: "_____-____"
                                      },
                                      model: {
                                        value:
                                          _vm.model.primayAddressInformation
                                            .zipCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.primayAddressInformation,
                                            "zipCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.primayAddressInformation.zipCode"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1606889171
                          )
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mb-4 pl-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm" },
                      [
                        _c("custom-input", {
                          attrs: { label: "Dirección (Línea 2):" },
                          model: {
                            value:
                              _vm.model.primayAddressInformation.addressLine2,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.model.primayAddressInformation,
                                "addressLine2",
                                $$v
                              )
                            },
                            expression:
                              "model.primayAddressInformation.addressLine2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: { regex: /(-?\d+(\.\d+)?)/ } },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.validationMessages
                                            .invalidCoordinate,
                                        error: errors[0],
                                        label: "Latitud:",
                                        placeholder: "____._________"
                                      },
                                      model: {
                                        value:
                                          _vm.model.primayAddressInformation
                                            .gpsLatitudee,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.primayAddressInformation,
                                            "gpsLatitudee",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.primayAddressInformation.gpsLatitudee"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4156602256
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: { regex: /(-?\d+(\.\d+)?)/ } },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.validationMessages
                                            .invalidCoordinate,
                                        error: errors[0],
                                        label: "Longitud:",
                                        placeholder: "____._________"
                                      },
                                      model: {
                                        value:
                                          _vm.model.primayAddressInformation
                                            .gpsLongitude,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.primayAddressInformation,
                                            "gpsLongitude",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.primayAddressInformation.gpsLongitude"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            367959733
                          )
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mb-4 pl-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-md-4" },
                      [
                        _c("custom-input", {
                          attrs: { label: "Dirección (Línea 3):" },
                          model: {
                            value:
                              _vm.model.primayAddressInformation.addressLine3,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.model.primayAddressInformation,
                                "addressLine3",
                                $$v
                              )
                            },
                            expression:
                              "model.primayAddressInformation.addressLine3"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("custom-input", {
                          attrs: {
                            label: "Anotaciones Adicionales:",
                            placeholder:
                              "Escribir información adicional de cómo llegar…"
                          },
                          model: {
                            value:
                              _vm.model.primayAddressInformation
                                .addressDescription,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.model.primayAddressInformation,
                                "addressDescription",
                                $$v
                              )
                            },
                            expression:
                              "model.primayAddressInformation.addressDescription"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("section-title", {
                    attrs: { title: "Información de Contacto Primario" }
                  }),
                  _c(
                    "div",
                    { staticClass: "mb-5 pl-3" },
                    [
                      _c("contact-information", {
                        attrs: { "civil-statuses": _vm.civilStatuses },
                        model: {
                          value: _vm.model.primaryContactInformation,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.model,
                              "primaryContactInformation",
                              $$v
                            )
                          },
                          expression: "model.primaryContactInformation"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.showHogarSection
            ? _c("wrapper", {
                attrs: {
                  icon: {
                    header: "fas fa-map-marker-alt",
                    inside: "fas fa-plus"
                  },
                  label: {
                    title: "Municipio(s)",
                    text: "Añadir Municipio(s)",
                    placeholder: "Escriba aquí para buscar un municipio...",
                    openMsg: "Presione aquí para añadir Municipio(s) ",
                    inner: "Municipio(s) seleccionado(s)"
                  },
                  list: _vm.homeMunicipalities,
                  save: _vm.getSelectedHomeMunicipalities,
                  "selected-items": _vm.wrapperSelection.model
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }